import { useRef } from 'react'

import { getAttachedRelatedServiceRequests } from '../../../../api'
import Button from '../../../Button'
import {
  AttachServiceRequestsModal,
  ConnectedRequestsMassEditModal,
  getConnectedRequestsMassEditInitialValues,
  getPreparedInitialValues,
} from '../../../Request'
import { ConnectedRequestsPreviewActions } from '../../ConnectedRequestsPreviewActions'

export function useConnectedRequestsPreview({
  requestData,
  onCloseModal,
  onMassEditSuccess,
  onSetModal,
}) {
  const requestId = requestData?.id

  const canEditRelatedRequests =
    requestData?.permissions?.can_edit_related_requests

  const massEditInitialValuesRef = useRef(
    getConnectedRequestsMassEditInitialValues()
  )

  function handleClickOpenMassEdit() {
    if (requestId) {
      const preparedInitialValues = getPreparedInitialValues(
        massEditInitialValuesRef.current
      )

      onSetModal(
        <ConnectedRequestsMassEditModal
          initialValues={preparedInitialValues}
          requestId={requestId}
          onClose={onCloseModal}
          onOpenConnectedRequestsPreview={handleClickOpenPreview}
          onSuccess={onMassEditSuccess}
        />
      )
    }
  }

  function handleClickOpenPreview(nextInitialValues) {
    if (requestId) {
      if (nextInitialValues) {
        massEditInitialValuesRef.current =
          getPreparedInitialValues(nextInitialValues)
      }

      onSetModal(
        <AttachServiceRequestsModal
          readonly
          Actions={ConnectedRequestsPreviewActions}
          actionsProps={{
            ButtonCancel: null,
            buttonAttachProps: {
              text: 'Modal.ConfirmBtnKey',
            },
            ...(canEditRelatedRequests
              ? {
                  ButtonMassEdit: Button.Text,
                  buttonMassEditProps: {
                    onClick: handleClickOpenMassEdit,
                  },
                }
              : null),
          }}
          counterProps={{
            text: 'Modal.AttachedRequestsCountBtnKey',
          }}
          entityId={requestId}
          headerProps={{
            text: 'Modal.AttachedRequestsTitleKey',
          }}
          loadItems={getAttachedRelatedServiceRequests}
          onClose={onCloseModal}
        />
      )
    }
  }

  return { handleClickOpenMassEdit, handleClickOpenPreview }
}
